module.exports = __webpack_public_path__ + "images/taco-sleep.0582d9f3bdb5060e7285.svg";